import { useState, useEffect } from "react";
import { CircleChevronLeft } from "lucide-react";
import { MedicineService } from "../services/api/medicine.service";
import { toast } from "react-hot-toast";
import { useRouter } from "@tanstack/react-router";

const AddNewMedicineModel = ({ onClose, medicineToEdit, onSave }) => {
  const [formData, setFormData] = useState({
    medicineName: "",
    medicineBrandName: "",
    medicineManufacturer: "",
    medicineSalt: "",
    originCountry: "",
    productForm: "",
    consumeType: "",
  });

  const router = useRouter();
  const pathname = router.state.location.pathname;

  // Populate form data if editing an existing medicine
  useEffect(() => {
    if (medicineToEdit) {
      setFormData({
        medicineName: medicineToEdit.medicineName || "",
        medicineBrandName: medicineToEdit.medicineBrandName || "",
        medicineManufacturer: medicineToEdit.medicineManufacturer || "",
        medicineSalt: medicineToEdit.medicineSalt || "",
        originCountry: medicineToEdit.originCountry || "",
        productForm: medicineToEdit.productForm || "",
        consumeType: medicineToEdit.consumeType || "",
      });
    }
  }, [medicineToEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (medicineToEdit) {
        // Update
        const response = await MedicineService.updateMedicine(
          medicineToEdit.id,
          formData
        );
        if (response.success) {
          toast.success("Medicine updated successfully");
          onSave?.();
          onClose();
        } else {
          toast.error(response.message || "Failed to update medicine");
        }
      } else {
        // Add new
        const response = await MedicineService.addNewMedicine(formData);
        if (response.success) {
          toast.success("Medicine added successfully");
          onSave?.();
          onClose();
          setFormData({
            consumeType: "",
            medicineBrandName: "",
            medicineManufacturer: "",
            medicineName: "",
            medicineSalt: "",
            originCountry: "",
            productForm: "",
          });
        } else {
          toast.error(response.message || "Failed to add medicine");
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="flex w-full">
      <div className="w-full">

        <div className="flex items-center mb-4">
          {pathname !== "/admin/stocks-orders/items" && (
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
             <CircleChevronLeft className="w-6 h-6 bg-[#808080] text-white rounded-full mr-2" />
            </button>
          )}
          <h2 className="font-medium text-lg text-emerald-600">
            {medicineToEdit ? "Edit Medicine" : "Add New Medicine"}
          </h2>
        </div>

        <div className="border border-gray-300 bg-white shadow-lg rounded-xl mt-3 p-4">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-medium mb-2">
              Medicine Name
            </label>
            <input
              type="text"
              name="medicineName"
              value={formData.medicineName}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-500"
              placeholder="Enter medicine name"
            />
          </div>

          <div className="flex space-x-4 mb-4">
            <div className="w-1/2">
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Medicine Brand Name
              </label>
              <input
                type="text"
                name="medicineBrandName"
                value={formData.medicineBrandName}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Enter brand name"
              />
            </div>

            <div className="w-1/2">
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Medicine Manufacturer
              </label>
              <input
                type="text"
                name="medicineManufacturer"
                value={formData.medicineManufacturer}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Enter manufacturer"
              />
            </div>
          </div>

          <div className="flex space-x-4 mb-4">
            <div className="w-1/2">
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Medicine Salt
              </label>
              <input
                type="text"
                name="medicineSalt"
                value={formData.medicineSalt}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Enter medicine salt"
              />
            </div>

            <div className="w-1/2">
              <label className="block text-gray-700 text-sm font-medium mb-2">
                Origin Country
              </label>
              <input
                type="text"
                name="originCountry"
                value={formData.originCountry}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-500"
                placeholder="Enter origin country"
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-medium mb-2">
              Product Form
            </label>
            <input
              type="text"
              name="productForm"
              value={formData.productForm}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-500"
              placeholder="Enter origin country"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-medium mb-2">
              Consume Type
            </label>
            <input
              type="text"
              name="consumeType"
              value={formData.consumeType}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-500"
              placeholder="Enter origin country"
            />
          </div>

          <div className="flex justify-end space-x-4">
            <button
              onClick={handleSubmit}
              className="px-4 py-2 text-sm font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 disabled:bg-gray-200 disabled:cursor-not-allowed "
            >
              {medicineToEdit ? "Update Medicine" : "Add Medicine"}
            </button>

            {pathname !== "/admin/stocks-orders/items" && (
              <button
                type="button"
                onClick={onClose}
                 className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 w-24"
              >
                Cancel
              </button>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default AddNewMedicineModel;
